import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";

const Isp = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box sx={{ px: 4 }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 400 }}>
            <TableBody>
              <TableRow>
                <TableCell sx={{ verticalAlign: "top", whiteSpace: "nowrap", bgcolor: "primary.main", width: 2 }}>
                  <Typography variant="h3">
                    The Challenge
                  </Typography>
                </TableCell>
                <TableCell align="left" sx={{ verticalAlign: "top" }}>
                  <Typography>Traditional cable subscriptions are declining, creating a revenue gap for ISPs. Customers crave flexibility and value, while competitors like Netflix and Hulu thrive.</Typography>
                </TableCell>
                <TableCell rowSpan={3} sx={{ verticalAlign: "top" }}>
                  <img sx={{ display: (isMobile) ? "none" : "block" }} src="/assets/images/sivootv-plus.jpg" width="4000" height="500"></img>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ verticalAlign: "top", whiteSpace: "nowrap", bgcolor: "primary.main" }}>
                  <Typography variant="h3">
                    The Solution
                  </Typography>
                </TableCell>
                <TableCell sx={{ verticalAlign: "top" }}>
                  <Typography>Partner with SivooTV+ to offer your customers the live streaming TV experience they want, bundled with your high-speed internet</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ verticalAlign: "top", whiteSpace: "nowrap", bgcolor: "primary.main" }}>
                  <Typography variant="h3">
                    The Offering
                  </Typography>
                </TableCell>
                <TableCell sx={{ verticalAlign: "top" }}>
                  <Typography>This offering outlines the U.S. platform product and opportunity for ISPs, cable operators and MDUs to acquire a “cable replacement” video streaming platform. The platform offers the national networks, programming content US viewers recognize, sports, Spanish-language channels and movies on the top-tier packages.</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ mx: 2, my: 3 }}>             
        <Typography variant="h3">
            Why SIVOOTV+ Is The Best Partner:
        </Typography>
        <TableContainer>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell sx={{ verticalAlign: "top" }}>
                <Box sx={{ mx: 5 }}>
                  <ol><li>
                  <Typography sx={{ textDecorationLine: "underline", color: "secondary.main" }}>
                    More Value for Customers
                  </Typography></li></ol>
                  <Box sx={{ mx: 3 }}>
                    <ul>
                        <li><b>Cord-cutting appeal:</b><br/>Ditch expensive cable packages with a comprehensive live TV streaming solution.</li>
                        <li><b>Flexible and affordable:</b><br/>No contracts, cancel anytime. Competitive pricing with familyfriendly features, up to five (5) simultaneous instances and 72-hr catch-up.</li>
                        <li><b>Superior user experience:</b><br/>Seamless integration with streaming devices, easy-to-use interface, and personalized recommendations.</li>
                        <li><b>Content library:</b><br/>Top sports channels, local networks, news, and entertainment, plus Sivoo Originals.</li>
                    </ul></Box>
                  </Box>
                </TableCell>
                <TableCell sx={{ verticalAlign: "top" }}>
                <Box sx={{ mx: 5 }}>
                  <ol start="2"><li>
                  <Typography sx={{ textDecorationLine: "underline", color: "secondary.main" }}>
                    Win-win for Partners
                  </Typography></li></ol>
                  <Box sx={{ mx: 3 }}>                        
                    <ul>
                        <li><b>Enhanced customer satisfaction:</b><br/>Increased retention and reduced churn, leading to higher customer lifetime value.</li>
                        <li><b>Bundled value proposition:</b><br/>Differentiate your offerings by delivering a complete entertainment package under one roof.</li>
                        <li><b>Data usage boost:</b><br/>Customers streaming high-quality content means increased data consumption and potential for higher internet plans.</li>
                        <li><b>New revenue streams:</b><br/>Co-branding and integration opportunities, potential for revenue sharing on add-on channels or Premium.</li>
                    </ul></Box>
                  </Box>
                </TableCell>
                <TableCell sx={{ verticalAlign: "top" }}>
                  <Box sx={{ mx: 5 }}>
                    <ol start="3"><li>
                    <Typography sx={{ textDecorationLine: "underline", color: "secondary.main" }}>
                        Collaboration options
                    </Typography></li></ol>
                    <Box sx={{ mx: 3 }}>
                        <ul>
                            <li><b>Bundled packages:</b><br/>Offer SivooTV+ at discounted rates with internet plans, highlighting cost savings and convenience.</li>
                            <li><b>Promotional campaigns:</b><br/>Joint marketing initiatives to introduce your customers to SivooTV+’s benefits.</li>
                            <li><b>Technical integration:</b><br/>Explore seamless user experience integration, like one-click sign-up and billing management.</li>
                        </ul>
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>  
      </Box>
      <Box sx={{ mx: 2 }}>
        <TableContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>                                       
                            <Typography variant="h3">
                                The Takeaways:
                            </Typography>
                            <Box sx={{ mx: 5, my: 2 }}>
                                <ul>
                                    <li>SivooTV+ complements your internet service, not replaces it. It's a strategic partnership that caters to the evolving
                        viewing habits of your customers while strengthening your competitive edge.</li>
                                    <li>Let's discuss how SivooTV+ can unlock new revenue streams and boost customer satisfaction for your ISP.</li>
                                    <li>Bonus: Offer a limited-time trial of SivooTV+ for your internet subscribers to showcase its value and drive adoption.</li>
                                    <li>By collaborating with SivooTV+, you can offer your customers the ultimate entertainment experience and solidify your
                        position as a leader in the evolving world of internet and TV.</li>
                                </ul>
                            </Box>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>    
        </TableContainer>
      </Box>
    </Box>
  );
};

export default Isp;
